<template>
  <div class="pct-w-100">
    <p v-if="!scenarios.length">No scenarios found</p>
    <div class="row flex-nowrap">
      <!--##################################################-->
      <!--region Scenarios-->
      <div class="col">
        <b-form-group v-if="!!scenarios.length">
          <template v-slot:label>
            <b>Select scenarios to share:</b><br>
            <b-form-checkbox
              v-model="flagAllScenariosSelected"
              aria-describedby="scenarios"
              aria-controls="scenarios"
              @change="toggleAllScenarios"
            >
              {{ flagAllScenariosSelected ? 'Un-select All' : 'Select All' }}
            </b-form-checkbox>
          </template>

          <div style=" max-height: 500px; overflow-y: visible; overflow-x: hidden;">
            <b-form-checkbox-group
              id="scenarios"
              v-model="selectedScenarios"
              :options="optionsScenarios"
              name="scenarios"
              class="ml-4"
              aria-label="Scenarios to share"
              stacked
            />
          </div>
        </b-form-group>
      </div>
      <!--endregion Scenarios-->
      <!--##################################################-->
      <!--region Users-->
      <div class="col">

        <b-form-group v-if="!!users.length">
          <template v-slot:label>
            <b>Select Users to share with:</b><br>
            <b-form-checkbox
              v-model="flagAllUsersSelected"
              aria-describedby="scenarios"
              aria-controls="scenarios"
              @change="toggleAllUsers"
            >
              {{ flagAllUsersSelected ? 'Un-select All' : 'Select All' }}
            </b-form-checkbox>
          </template>

          <div style=" max-height: 500px; overflow-y: visible; overflow-x: hidden;">
            <b-form-checkbox-group
              id="users"
              v-model="selectedUsers"
              :options="optionsUsers"
              name="scenarios"
              class="ml-4"
              aria-label="Users to share with"
              stacked
            />
          </div>
        </b-form-group>

      </div>
      <!--endregion Users-->
      <!--##################################################-->
    </div>


    <b-row>
      <b-col class="text-right">
        <b-button @click="cancel">Cancel</b-button>
        <b-button
          variant="primary"
          :disabled="!selectedScenarios.length"
          @click="share"
        >
          Ok
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import service         from "@/services/HttpRequestService";
import {TRACE_ERROR}   from "@/constants";
import ObjSpinnerState from "@/components/common/spinner/ObjSpinnerState";

export default {
  props: {
    scenarios: {
      type:    Array,
      default: () => []
    }
  },
  data() {
    return {
      users:                    [],
      selectedUsers:            [],
      flagAllUsersSelected:     false,
      selectedScenarios:        [],
      flagAllScenariosSelected: false
    }
  },
  async created() {
    try {
      ObjSpinnerState.isOn = true;
      let users            = await service.getUsers();
      this.users           = users.data;
    } catch (err) {
      await service.log(TRACE_ERROR, err.Message, err.stack);
    } finally {
      ObjSpinnerState.isOn = false;
    }
  },
  computed: {
    optionsScenarios() {
      return (this.scenarios || [])
        .map(({
                Id:           value,
                ScenarioName: name,
                DealName:     dealName,
                Vendor:       vendor
              }) => {
          const vendorAndDeal     = [vendor, dealName].filter(Boolean);
          const vendorAndDealText = vendorAndDeal.length ? ` (${vendorAndDeal.join(', ')})` : '';
          const text              = `${name}${vendorAndDealText}`
          return {value, text};
        });
    },
    optionsUsers() {
      return (this.users || [])
        .map(({
                Id:       value,
                Username: name
              }) => {
          const text = `${name}`
          return {value, text};
        });
    }
  },
  methods:  {
    toggleAllScenarios(checked) {
      this.selectedScenarios = checked ? this.optionsScenarios.map(({value}) => value) : [];
    },
    toggleAllUsers(checked) {
      this.selectedUsers = checked ? this.optionsUsers.map(({value}) => value) : [];
    },
    share() {
      this.$emit('share', this.selectedScenarios, this.selectedUsers);
    },
    cancel() {
      this.$emit('cancel');
    }
  },
  watch:    {
    selectedScenarios(newVal, oldVal) {
      if (newVal.length === 0) {
        this.flagAllScenariosSelected = false;
      } else if (newVal.length === this.optionsScenarios.length) {
        this.flagAllScenariosSelected = true;
      } else {
        this.flagAllScenariosSelected = false;
      }
    }
  }
}
</script>
